import React, { createContext, useContext, useState } from "react";
import { getFormattedDate } from "../Utils";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    user_id: null,
    start_date: null,
    end_date: null,
  });

  const updateFilter = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
    }));
  };
  const getFormattedData = () => {
    return {
      user_id: filters.user_id,
      start_date: getFormattedDate(filters.start_date),
      end_date: getFormattedDate(filters.end_date),
    };
  };

  return (
    <DashboardContext.Provider
      value={{ filters, updateFilter, getFormattedData }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
export const useDashboard = () => {
  return useContext(DashboardContext);
};
